import type { Template } from "@/types";

export const PO_07_H5_V2: Template[] = [
    {
        id: "po-07-h5v2-01",
        name: "PO 01 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 46, y: 168, width: 278, height: 188, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 364, width: 278, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 46, y: 560, width: 278, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 332, y: 168, width: 304, height: 580, rotation: 0, imageRotation: 0 },
            { id: "5", x: 755, y: 257, width: 264, height: 197, rotation: 0, imageRotation: 0 },
            { id: "6", x: 755, y: 462, width: 264, height: 197, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1027, y: 257, width: 265, height: 402, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-07-h5v2-02",
        name: "PO 02 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 77, y: 184, width: 532, height: 355, rotation: 0, imageRotation: 0 },
            { id: "2", x: 77, y: 547, width: 122, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 208, y: 547, width: 273, height: 185, rotation: 0, imageRotation: 0 },
            { id: "4", x: 489, y: 547, width: 121, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 765, y: 184, width: 532, height: 363, rotation: 0, imageRotation: 0 },
            { id: "6", x: 765, y: 555, width: 262, height: 177, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1035, y: 555, width: 262, height: 177, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-03",
        name: "PO 03 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 45, y: 184, width: 262, height: 178, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 370, width: 262, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 45, y: 555, width: 262, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 315, y: 184, width: 331, height: 548, rotation: 0, imageRotation: 0 },
            { id: "5", x: 756, y: 184, width: 547, height: 280, rotation: 0, imageRotation: 0 },
            { id: "6", x: 756, y: 472, width: 362, height: 259, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1126, y: 472, width: 177, height: 259, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-04",
        name: "PO 04 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 250, width: 586, height: 416, rotation: 0, imageRotation: 0 },
            { id: "2", x: 594, y: 250, width: 150, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1068, y: 250, width: 306, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 752, y: 250, width: 308, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1225, y: 462, width: 149, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 594, y: 462, width: 308, height: 204, rotation: 0, imageRotation: 0 },
            { id: "7", x: 910, y: 462, width: 307, height: 204, rotation: 0, imageRotation: 0 }
        ],

    },

    {
        id: "po-07-h5v2-05",
        name: "PO 05 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 52, y: 252, width: 358, height: 244, rotation: 0, imageRotation: 0 },
            { id: "2", x: 418, y: 252, width: 358, height: 244, rotation: 0, imageRotation: 0 },
            { id: "3", x: 52, y: 504, width: 236, height: 160, rotation: 0, imageRotation: 0 },
            { id: "4", x: 296, y: 504, width: 236, height: 160, rotation: 0, imageRotation: 0 },
            { id: "5", x: 540, y: 504, width: 236, height: 160, rotation: 0, imageRotation: 0 },
            { id: "6", x: 784, y: 252, width: 265, height: 412, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1057, y: 252, width: 265, height: 412, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-06",
        name: "PO 06 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 56, y: 136, width: 627, height: 427, rotation: 0, imageRotation: 0 },
            { id: "2", x: 691, y: 136, width: 310, height: 427, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1009, y: 136, width: 309, height: 427, rotation: 0, imageRotation: 0 },
            { id: "4", x: 56, y: 571, width: 310, height: 209, rotation: 0, imageRotation: 0 },
            { id: "5", x: 374, y: 571, width: 309, height: 209, rotation: 0, imageRotation: 0 },
            { id: "6", x: 691, y: 571, width: 310, height: 209, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1009, y: 571, width: 309, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-07",
        name: "PO 07 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 190, width: 240, height: 174, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 372, width: 240, height: 173, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 553, width: 240, height: 173, rotation: 0, imageRotation: 0 },
            { id: "4", x: 248, y: 190, width: 388, height: 536, rotation: 0, imageRotation: 0 },
            { id: "5", x: 644, y: 190, width: 386, height: 536, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1038, y: 190, width: 336, height: 264, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1038, y: 462, width: 336, height: 264, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-08",
        name: "PO 08 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 190, width: 240, height: 174, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 372, width: 240, height: 173, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 553, width: 240, height: 173, rotation: 0, imageRotation: 0 },
            { id: "4", x: 248, y: 190, width: 388, height: 536, rotation: 0, imageRotation: 0 },
            { id: "5", x: 644, y: 190, width: 336, height: 264, rotation: 0, imageRotation: 0 },
            { id: "6", x: 644, y: 462, width: 336, height: 264, rotation: 0, imageRotation: 0 },
            { id: "7", x: 988, y: 190, width: 386, height: 536, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-09",
        name: "PO 09 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 56, y: 165, width: 200, height: 141, rotation: 0, imageRotation: 0 },
            { id: "2", x: 56, y: 314, width: 200, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 56, y: 463, width: 200, height: 140, rotation: 0, imageRotation: 0 },
            { id: "4", x: 56, y: 611, width: 200, height: 140, rotation: 0, imageRotation: 0 },
            { id: "5", x: 264, y: 165, width: 848, height: 586, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1120, y: 165, width: 198, height: 289, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1120, y: 462, width: 198, height: 289, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h5v2-10",
        name: "PO 10 - H5V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h5_v2_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 56, y: 165, width: 848, height: 586, rotation: 0, imageRotation: 0 },
            { id: "2", x: 912, y: 165, width: 200, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 912, y: 313, width: 200, height: 141, rotation: 0, imageRotation: 0 },
            { id: "4", x: 912, y: 462, width: 200, height: 141, rotation: 0, imageRotation: 0 },
            { id: "5", x: 912, y: 611, width: 200, height: 140, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1120, y: 165, width: 198, height: 289, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1120, y: 462, width: 198, height: 289, rotation: 0, imageRotation: 0 }
        ],
    },
];
